<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            Assignment Roya
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-form-card mb-4">
      <CCardBody class="px-3">
        <b-tabs justified @activate-tab="promptChangeTabs">
          <b-tab active title="Office">
            <CRow class="mt-4">
              <CCol class="col-sm-12 ml-5">
                <CForm>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-form-select v-model="officeTable.filterType" :options="officeTable.filterOptions" @change="onChangeFilterType"></b-form-select>
                    </b-input-group-prepend>
                    <b-input-group-prepend>
                      <b-form-input 
                        maxlength="50" v-if="officeTable.filterType == 'contractNo'" type="text" placeholder="Search" 
                        :value="officeTable.filterValue" @input="officeTable.filterValue = $helper.parseNumber($event)"
                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                      ></b-form-input>
                      <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="officeTable.filterValue"></b-form-input>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <CButton size="sm" color="primary" type="submit" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="filterOfficeTableItems">
                        <CIcon name="cil-magnifying-glass" />
                      </CButton>
                    </b-input-group-append>
                  </b-input-group>
                </CForm>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="col-sm-12 mt-4">
                <b-table striped hover show-empty
                  responsive="xl"
                  :items="officeTable.items"
                  :fields="officeTable.fields"
                  :busy="!officeTable.isLoaded"
                  no-local-sorting no-sort-reset
                >
                <template #cell(no)="row">
                  {{ $helper.showData(row.index+1, "number") }}.
                </template>
                <template #cell(officeCode)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(nameFull)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                  <template slot="empty">
                    <div v-if="!officeTable.isLoaded" class="text-center">
                      <b-spinner label="Fetching Data..."></b-spinner>
                    </div> 
                    <div v-else class="text-center">
                      Tidak ada data
                    </div> 
                  </template>
                  <template #cell(action)="row">
                    <b-form-checkbox
                      :checked="isOfficeCheckedItem(row.item.officeCode)"
                      @change="onOfficeCheckItem($event, row.item.officeCode)"
                    ></b-form-checkbox>
                  </template>
                </b-table>
                <CCardFooter>
                  <PageSizer :totalRows="officeTable.totalRows" :page="officeTable.currentPage" :options="tablePageOptions" @page-change="onOfficePageChange" />
                </CCardFooter>
              </CCol>
            </CRow>
            <CRow class="pt-3">
              <CCol class="col-12">
                <CButton color="primary" class="float-right" style="width:7rem" type="button" :disabled="isSubmitting" @click="saveOfficeItems">
                  <b-spinner small v-if="isSubmitting" />
                  {{ isSubmitting ? '' : 'Save' }}
                </CButton>
                <b-btn variant="secondary" class="mr-2 float-right" @click="clearOfficeChanges">Clear</b-btn>
              </CCol>
            </CRow>
          </b-tab>
          <b-tab title="Business Unit">
            <CRow>
              <CCol class="col-sm-12 mt-4">
                <b-table striped hover show-empty
                  responsive="xl"
                  :items="bussUnitTable.items"
                  :fields="bussUnitTable.fields"
                  :busy="!bussUnitTable.isLoaded"
                  no-local-sorting no-sort-reset
                >
                <template #cell(no)="row">
                  {{ $helper.showData(row.index+1, "number") }}.
                </template>
                <template #cell(bussUnit)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(bussUnitDesc)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                  <template slot="empty">
                    <div v-if="!bussUnitTable.isLoaded" class="text-center">
                      <b-spinner label="Fetching Data..."></b-spinner>
                    </div> 
                    <div v-else class="text-center">
                      Tidak ada data
                    </div> 
                  </template>
                  <template #cell(action)="row">
                    <b-form-checkbox
                      :checked="isBussUnitCheckedItem(row.item.bussUnit)"
                      @change="onBussUnitCheckItem($event, row.item.bussUnit)"
                    ></b-form-checkbox>
                  </template>
                </b-table>
                <CCardFooter>
                  <PageSizer :totalRows="bussUnitTable.totalRows" :page="bussUnitTable.currentPage" :options="tablePageOptions" @page-change="onBussUnitPageChange" />
                </CCardFooter>
              </CCol>
            </CRow>
            <CRow class="pt-3">
              <CCol class="col-12">
                <CButton color="primary" class="float-right" style="width:7rem" type="button" :disabled="isSubmitting" @click="saveBussUnitItems">
                  <b-spinner small v-if="isSubmitting" />
                  {{ isSubmitting ? '' : 'Save' }}
                </CButton>
                <b-btn variant="secondary" class="mr-2 float-right" @click="clearBussUnitChanges">Clear</b-btn>
              </CCol>
            </CRow>
          </b-tab>
          <b-tab title="Platform">
            <CRow>
              <CCol class="col-sm-12 mt-4">
                <b-table striped hover show-empty
                  responsive="xl"
                  :items="platformTable.items"
                  :fields="platformTable.fields"
                  :busy="!platformTable.isLoaded"
                  no-local-sorting no-sort-reset
                >
                <template #cell(no)="row">
                  {{ $helper.showData(row.index+1, "number") }}.
                </template>
                <template #cell(id)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(name)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                  <template slot="empty">
                    <div v-if="!platformTable.isLoaded" class="text-center">
                      <b-spinner label="Fetching Data..."></b-spinner>
                    </div> 
                    <div v-else class="text-center">
                      Tidak ada data
                    </div> 
                  </template>
                  <template #cell(action)="row">
                    <b-form-checkbox
                      :checked="isPlatformCheckedItem(row.item.id)"
                      @change="onPlatformCheckItem($event, row.item.id)"
                    ></b-form-checkbox>
                  </template>
                </b-table>
                <CCardFooter>
                  <PageSizer :totalRows="platformTable.totalRows" :page="platformTable.currentPage" :options="tablePageOptions" @page-change="onPlatformPageChange" />
                </CCardFooter>
              </CCol>
            </CRow>
            <CRow class="pt-3">
              <CCol class="col-12">
                <CButton color="primary" class="float-right" style="width:7rem" type="button" :disabled="isSubmitting" @click="savePlatformItems">
                  <b-spinner small v-if="isSubmitting" />
                  {{ isSubmitting ? '' : 'Save' }}
                </CButton>
                <b-btn variant="secondary" class="mr-2 float-right" @click="clearPlatformChanges">Clear</b-btn>
              </CCol>
            </CRow>
          </b-tab>
          <b-tab title="Company">
            <CRow>
              <CCol class="col-sm-12 mt-4">
                <b-table striped hover show-empty
                  responsive="xl"
                  :items="companyTable.items"
                  :fields="companyTable.fields"
                  :busy="!companyTable.isLoaded"
                  no-local-sorting no-sort-reset
                >
                <template #cell(no)="row">
                  {{ $helper.showData(row.index+1, "number") }}.
                </template>
                <template #cell(id)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                <template #cell(name)="row">
                  {{ $helper.showData(row.value, "string") }}
                </template>
                  <template slot="empty">
                    <div v-if="!companyTable.isLoaded" class="text-center">
                      <b-spinner label="Fetching Data..."></b-spinner>
                    </div> 
                    <div v-else class="text-center">
                      Tidak ada data
                    </div> 
                  </template>
                  <template #cell(action)="row">
                    <b-form-checkbox
                      :checked="isCompanyCheckedItem(row.item.id)"
                      @change="onCompanyCheckItem($event, row.item.id)"
                    ></b-form-checkbox>
                  </template>
                </b-table>
                <CCardFooter>
                  <PageSizer :totalRows="companyTable.totalRows" :page="companyTable.currentPage" :options="tablePageOptions" @page-change="onCompanyPageChange" />
                </CCardFooter>
              </CCol>
            </CRow>
            <CRow class="pt-3">
              <CCol class="col-12">
                <CButton color="primary" class="float-right" style="width:7rem" type="button" :disabled="isSubmitting" @click="saveCompanyItems">
                  <b-spinner small v-if="isSubmitting" />
                  {{ isSubmitting ? '' : 'Save' }}
                </CButton>
                <b-btn variant="secondary" class="mr-2 float-right" @click="clearCompanyChanges">Clear</b-btn>
              </CCol>
            </CRow>
          </b-tab>
        </b-tabs>
      </CCardBody>
    </CCard>
  </CContainer>
</template>


<script>
export default {
  name: 'ConfigAssignmentRoya',
  data() {
    return {

      isSubmitting: false,
      isChanged: false,

      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],

      assignModalData: {
        isShowing: false,
        isSubmitting: false,
        mou: {
          /*
            "mouCode": "string",
            "mouName": "string",
            "mouId": "string
          */
          value: '',
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          payloadKey: "mouId"
        },
      },

      officeTable: {

        isLoaded: false,
        hasFetched: false,

        fields: [
          { key: "no", label: "No.", sortable: false },
          { key: "officeCode", label: "Kode Area", sortable: false },
          { key: "nameFull", label: "Nama Office", sortable: false },
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        fetchedItems: [],
        checkedItems: [],

        filterType: "nameFull",
        filterOptions: [
          { value: "officeCode", text: "Kode Area" },
          { value: "nameFull", text: "Nama Office" }
        ],
        filterValue: "",

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      bussUnitTable: {

        isLoaded: false,
        hasFetched: false,

        fields: [
          { key: "no", label: "No.", sortable: false },
          { key: "bussUnit", label: "Kode Unit", sortable: false },
          { key: "bussUnitDesc", label: "Deskripsi", sortable: false },
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        fetchedItems: [],
        checkedItems: [],

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      platformTable: {

        isLoaded: false,
        hasFetched: false,

        fields: [
          { key: "no", label: "No.", sortable: false },
          { key: "id", label: "Kode Platform", sortable: false },
          { key: "name", label: "Nama Platform", sortable: false },
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        fetchedItems: [],
        checkedItems: [],

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      companyTable: {

        isLoaded: false,
        hasFetched: false,

        fields: [
          { key: "no", label: "No.", sortable: false },
          { key: "id", label: "ID Company", sortable: false },
          { key: "name", label: "Nama Company", sortable: false },
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        fetchedItems: [],
        checkedItems: [],

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    onChangeFilterType() {
      this.officeTable.filterValue = ""
    },

    saveOfficeItems() {
      let payload = new FormData()
      payload.append("listId", this.officeTable.checkedItems)
      payload.append("toAssign", "office")
      let postUrl = '/assignmentRoya/setAssignmentRoya/'

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Simpan Perubahan Office Berhasil!")
            this.officeTable.fetchedItems = this.officeTable.checkedItems
            this.isChanged = false
            this.getOfficeTableItems()
          }
          else{
            this.$helper.toastError(this, "Simpan Perubahan Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Simpan Perubahan Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Simpan Perubahan Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
        })
        .finally(() => {
          this.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    saveBussUnitItems() {
      let payload = new FormData()
      payload.append("listId", this.bussUnitTable.checkedItems)
      payload.append("toAssign", "bussUnit")
      let postUrl = '/assignmentRoya/setAssignmentRoya/'

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Simpan Perubahan Business Unit Berhasil!")
            this.bussUnitTable.fetchedItems = this.bussUnitTable.checkedItems
            this.isChanged = false
            this.getBussUnitTableItems()
          }
          else{
            this.$helper.toastError(this, "Simpan Perubahan Business Unit Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Simpan Perubahan Business Unit Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Simpan Perubahan Business Unit Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
        })
        .finally(() => {
          this.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    savePlatformItems() {
      let payload = new FormData()
      payload.append("listId", this.platformTable.checkedItems)
      payload.append("toAssign", "platform")
      let postUrl = '/assignmentRoya/setAssignmentRoya/'

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Simpan Perubahan Platform Berhasil!")
            this.platformTable.fetchedItems = this.platformTable.checkedItems
            this.isChanged = false
            this.getPlatformTableItems()
          }
          else{
            this.$helper.toastError(this, "Simpan Perubahan Platform Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Simpan Perubahan Platform Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Simpan Perubahan Platform Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
        })
        .finally(() => {
          this.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    saveCompanyItems() {
      let payload = new FormData()
      payload.append("listId", this.companyTable.checkedItems)
      payload.append("toAssign", "company")
      let postUrl = '/assignmentRoya/setAssignmentRoya/'

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Simpan Perubahan Company Berhasil!")
            this.companyTable.fetchedItems = this.companyTable.checkedItems
            this.isChanged = false
            this.getCompanyTableItems()
          }
          else{
            this.$helper.toastError(this, "Simpan Perubahan Company Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Simpan Perubahan Company Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Simpan Perubahan Company Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
        })
        .finally(() => {
          this.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    filterOfficeTableItems(event) {
      event.preventDefault()
      this.getOfficeTableItems()
    },

    getOfficeTableItems(page = 1) {
      this.officeTable.isLoaded = false
      this.officeTable.items = []
      if(isNaN(page)) {
        this.officeTable.currentPage = 1
      }
      else {
        this.officeTable.currentPage = page
      }
      // URL builder
      let getUrl = "/office/getAll"
      let params = this.$helper.getBasePagedQuery(this.officeTable.currentPage - 1, this.officeTable.perPage)

      if(!this.$helper.isEmpty(this.officeTable.filterValue)) {
        params['filterType'] = this.officeTable.filterType
        params['filterValue'] = this.officeTable.filterValue
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterConfigAssignmentRoyaFilterType", this.officeTable.filterType)
          sessionStorage.setItem("filterConfigAssignmentRoyaFilterValue", this.officeTable.filterValue)
          this.officeTable.items = response.data.data.data
          this.officeTable.totalRows = response.data.data.totalElements
          this.officeTable.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.officeTable.isLoaded = true
      })
    },
    getBussUnitTableItems(page = 1) {
      this.bussUnitTable.isLoaded = false
      this.bussUnitTable.items = []
      if(isNaN(page)) {
        this.bussUnitTable.currentPage = 1
      }
      else {
        this.bussUnitTable.currentPage = page
      }
      // URL builder
      let getUrl = "/assignmentRoya/getBusinessUnitPaged"
      let params = this.$helper.getBasePagedQuery(this.bussUnitTable.currentPage - 1, this.bussUnitTable.perPage)

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.bussUnitTable.items = response.data.data.data
          this.bussUnitTable.totalRows = response.data.data.totalElements
          this.bussUnitTable.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.bussUnitTable.isLoaded = true
      })
    },
    getPlatformTableItems(page = 1) {
      this.platformTable.isLoaded = false
      this.platformTable.items = []
      if(isNaN(page)) {
        this.platformTable.currentPage = 1
      }
      else {
        this.platformTable.currentPage = page
      }
      // URL builder
      let getUrl = "/assignmentRoya/getPlatformPaged"
      let params = this.$helper.getBasePagedQuery(this.platformTable.currentPage - 1, this.platformTable.perPage)

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.platformTable.items = response.data.data.data
          this.platformTable.totalRows = response.data.data.totalElements
          this.platformTable.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar Platform Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Platform Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Platform Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.platformTable.isLoaded = true
      })
    },
    getCompanyTableItems(page = 1) {
      this.companyTable.isLoaded = false
      this.companyTable.items = []
      if(isNaN(page)) {
        this.companyTable.currentPage = 1
      }
      else {
        this.companyTable.currentPage = page
      }
      // URL builder
      let getUrl = "/assignmentRoya/getCompanyPaged"
      let params = this.$helper.getBasePagedQuery(this.companyTable.currentPage - 1, this.companyTable.perPage)

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.companyTable.items = response.data.data.data
          this.companyTable.totalRows = response.data.data.totalElements
          this.companyTable.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar Company Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Company Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Company Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.companyTable.isLoaded = true
      })
    },

    onOfficePageChange(newPage) {
      this.getOfficeTableItems(newPage)
    },
    onBussUnitPageChange(newPage) {
      this.getBussUnitTableItems(newPage)
    },
    onPlatformPageChange(newPage) {
      this.getPlatformTableItems(newPage)
    },
    onCompanyPageChange(newPage) {
      this.getCompanyTableItems(newPage)
    },

    getOfficeAssignedItems() {
      this.officeTable.isLoaded = false
      this.officeTable.fetchedItems = []

      // URL builder
      let getUrl = "/assignmentRoya/getAssignedOffice"

      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.officeTable.fetchedItems = response.data.data
          this.officeTable.hasFetched = true
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Assigned Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.officeTable.isLoaded = true
      })
    },
    getBussUnitAssignedItems() {
      this.bussUnitTable.isLoaded = false
      this.bussUnitTable.fetchedItems = []

      // URL builder
      let getUrl = "/assignmentRoya/getAssignedBusinessUnit"

      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.bussUnitTable.fetchedItems = response.data.data
          this.bussUnitTable.hasFetched = true
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Business Unit Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Assigned Business Unit Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Business Unit Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.bussUnitTable.isLoaded = true
      })
    },
    getPlatformAssignedItems() {
      this.platformTable.isLoaded = false
      this.platformTable.fetchedItems = []

      // URL builder
      let getUrl = "/assignmentRoya/getAssignedPlatform"

      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.platformTable.fetchedItems = response.data.data
          this.platformTable.hasFetched = true
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Platform Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Assigned Platform Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Platform Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.platformTable.isLoaded = true
      })
    },
    getCompanyAssignedItems() {
      this.companyTable.isLoaded = false
      this.companyTable.fetchedItems = []

      // URL builder
      let getUrl = "/assignmentRoya/getAssignedCompany"

      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.companyTable.fetchedItems = response.data.data
          this.companyTable.hasFetched = true
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Company Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Assigned Company Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Assigned Company Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.companyTable.isLoaded = true
      })
    },

    isOfficeCheckedItem(officeCode) {
      return this.officeTable.checkedItems.includes(officeCode)
    },
    isBussUnitCheckedItem(bussUnit) {
      return this.bussUnitTable.checkedItems.includes(bussUnit)
    },
    isPlatformCheckedItem(id) {
      return this.platformTable.checkedItems.includes(id)
    },
    isCompanyCheckedItem(id) {
      return this.companyTable.checkedItems.includes(id)
    },

    onOfficeCheckItem(checked, officeCode) {
      this.isChanged = true
      if(checked){
        this.officeTable.checkedItems.push(officeCode)
      }
      else{
        const idx = this.officeTable.checkedItems.indexOf(officeCode)
        if (idx > -1) this.officeTable.checkedItems.splice(idx, 1)
      }
    },
    onBussUnitCheckItem(checked, bussUnit) {
      this.isChanged = true
      if(checked){
        this.bussUnitTable.checkedItems.push(bussUnit)
      }
      else{
        const idx = this.bussUnitTable.checkedItems.indexOf(bussUnit)
        if (idx > -1) this.bussUnitTable.checkedItems.splice(idx, 1)
      }
    },
    onPlatformCheckItem(checked, id) {
      this.isChanged = true
      if(checked){
        this.platformTable.checkedItems.push(id)
      }
      else{
        const idx = this.platformTable.checkedItems.indexOf(id)
        if (idx > -1) this.platformTable.checkedItems.splice(idx, 1)
      }
    },
    onCompanyCheckItem(checked, id) {
      this.isChanged = true
      if(checked){
        this.companyTable.checkedItems.push(id)
      }
      else{
        const idx = this.companyTable.checkedItems.indexOf(id)
        if (idx > -1) this.companyTable.checkedItems.splice(idx, 1)
      }
    },

    clearOfficeChanges(){
      this.officeTable.checkedItems = this.$lodash.cloneDeep(this.officeTable.fetchedItems)
      this.isChanged = false
      this.getOfficeTableItems()
    },
    clearBussUnitChanges(){
      this.bussUnitTable.checkedItems = this.$lodash.cloneDeep(this.bussUnitTable.fetchedItems)
      this.isChanged = false
      this.getBussUnitTableItems()
    },
    clearPlatformChanges(){
      this.platformTable.checkedItems = this.$lodash.cloneDeep(this.platformTable.fetchedItems)
      this.isChanged = false
      this.getPlatformTableItems()
    },
    clearCompanyChanges(){
      this.companyTable.checkedItems = this.$lodash.cloneDeep(this.companyTable.fetchedItems)
      this.isChanged = false
      this.getCompanyTableItems()
    },

    promptChangeTabs(newIdx, prevIdx, event){
      if(this.isChanged){
        let confirmed = confirm('Perubahan yang belum disimpan akan dihapuskan. Apakah anda yakin ingin pindah menu halaman?')
        if(!confirmed){
          event.preventDefault()
          return
        }
      }
      this.onChangeTabs(newIdx)
    },
    onChangeTabs(idx){
      if(idx == 0){
        if(!this.officeTable.hasFetched){
          this.getOfficeAssignedItems().then(_ => {
            this.clearOfficeChanges()
          })
        }
        else{
          this.clearOfficeChanges()
        }
      }
      else if(idx == 1){
        if(!this.bussUnitTable.hasFetched){
          this.getBussUnitAssignedItems().then(_ => {
            this.clearBussUnitChanges()
          })
        }
        else{
          this.clearBussUnitChanges()
        }
      }
      else if(idx == 2){
        if(!this.platformTable.hasFetched){
          this.getPlatformAssignedItems().then(_ => {
            this.clearPlatformChanges()
          })
        }
        else{
          this.clearPlatformChanges()
        }
      }
      else if(idx == 3){
        if(!this.companyTable.hasFetched){
          this.getCompanyAssignedItems().then(_ => {
            this.clearCompanyChanges()
          })
        }
        else{
          this.clearCompanyChanges()
        }
      }
    }
  },
  computed: {
  },
  mounted() {
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigAssignmentRoyaFilterType"))){
      this.officeTable.filterType = sessionStorage.getItem("filterConfigAssignmentRoyaFilterType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigAssignmentRoyaFilterValue"))){
      this.officeTable.filterValue = sessionStorage.getItem("filterConfigAssignmentRoyaFilterValue")
    }
    this.getOfficeAssignedItems().then(_ => {
      this.clearOfficeChanges()
    })
  },
  created(){
  }
}
</script>

<style>

</style>
